export default {
	state: {
		accounts: []
	},

	actions: {
		getAccounts(actionContext) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					var columns = "" +
						"a.id, " +
						"a.name";

					var tableName = "" +
						"@db.account a";

					var filter = "" +
						"a.inactive = 0";

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/GetTableData?columns=${columns}&tableName=${tableName}&filter=${filter}`)
						.then(response => {
							var records = actionContext.rootGetters["MopaneApi/getObjectArrayFromTable"](response.data)

							actionContext.commit("setAccounts", records)
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		}
	},

	mutations: {
		setAccounts(state, accounts) {
			state.accounts = accounts
		}
	},

	namespaced: true
}